var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("neo > "+_vm._s(_vm.displayingMessage)),(_vm.active)?_c('Caret',{attrs:{"blink":!_vm.isInputting}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }